<template>
  <div class="fl-navigation">
    <fl-navigation-item
      v-for="link in list"
      :key="link.name ?? link.id"
      v-bind="link"
    />
  </div>
</template>

<script>
import FlNavigationItem from "@/layouts/FlNavigation/FlNavigationItem.vue";

export default {
  components: {FlNavigationItem},
  props: {
    list: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.fl-navigation {
  @include grid;
}
</style>
